import * as R from 'ramda';
import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { setRegion } from './setRegion';
import { fetchExtensionRegionCached } from '../../services/fetchExtensionRegion';
import { getCookie } from '../../utils/cookie_helper';
import { EXPANSION_REGION_DISABLE_COOKIE } from '../../constants/region';

export type TResetRegionType = 'filters/reset_region';

export interface IResetRegion extends Action<TResetRegionType> {
  type: TResetRegionType;
}

export type TResetRegion = IResetRegion;

export function resetRegion(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      filters: { jsonQuery },
      geoSwitcher,
      mainpage: {
        regionsData: { subdomainRegionId },
      },
    } = getState();

    const userRegion = geoSwitcher.region?.id || subdomainRegionId;

    const extensionRegion = !getCookie(document.cookie, EXPANSION_REGION_DISABLE_COOKIE)
      ? await fetchExtensionRegionCached(context, { regionId: userRegion })
      : null;

    const currentRegion = extensionRegion?.id ?? userRegion;

    if (jsonQuery.region && R.equals(jsonQuery.region.value, [currentRegion])) {
      return;
    }

    dispatch(setRegion([currentRegion]));
  };
}
